import { render, staticRenderFns } from "./TotalPriceAlert.vue?vue&type=template&id=41bad334"
import script from "./TotalPriceAlert.vue?vue&type=script&lang=js"
export * from "./TotalPriceAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports